import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import UndoIcon from "@mui/icons-material/Undo";
import { usStates } from "../../utils/constant";
import moment from "moment";
import { enqueueSnackbar } from "notistack";

const INITIAL_VALUES = {
  states: [],
  startDate: "",
  endDate: "",
};

export default function CasesFilterAttorney(props) {
  const {
    memberList,
    selectedSourceId,
    setSelectedSourceId,
    setPage,
    setPageCount,
    applyFilters,
    setSectorFilter,
    sectorFilter,
    setTypeFilter,
    typeFilter,
    states,
    setStates,
    clearFilters,

    caseType,
    selectedOccurancePeriod,
    setselectedOccurancePeriodId,
    setCaseType,
    setStartDate,
    startDate,
    setEndDate,
    endDate,
    setCaseStatus,
    caseStatus,
    tempFilters,
    setTempFilters,
    setCaseData,
    caseDatas,
  } = props;

  const [inputs, setInputs] = useState(INITIAL_VALUES);

  // useEffect(() => {
  //   if (typeFilter !== "clients") {
  //     setSectorFilter("");
  //   }
  // }, [typeFilter]);
  const handleOccurrencePeriodChange = (value) => {
    setselectedOccurancePeriodId(value);

    if (value === "today") {
      setStartDate(moment().startOf("day").toDate());
      setEndDate(null); // ❌ Don't send endDate
    } else if (value === "yesterday") {
      setStartDate(moment().subtract(1, "day").startOf("day").toDate());
      setEndDate(null); // ❌ Don't send endDate
    } else if (value === "custom_dates") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleApply = () => {
    if (selectedOccurancePeriod === "custom_dates") {
      if (!startDate || !endDate) {
        enqueueSnackbar(
          "Both start and end dates are required for custom dates",
          { variant: "error" }
        );
        return;
      }
    }

    applyFilters({
      caseType: selectedSourceId,
      states: inputs.states,
      startDate: inputs.startDate,
      endDate: inputs.endDate,
      occurrencePeriod: selectedOccurancePeriod,
    });
  };

  const handleClear = () => {
    setInputs(INITIAL_VALUES);
    setEndDate(null);
    setStartDate(null);
    setCaseType("");
    setselectedOccurancePeriodId("");
    clearFilters();
  };

  return (
    <form>
      {/* Case Type */}
      <FormControl required fullWidth margin="normal">
        <InputLabel id="source-select-label">Case Type</InputLabel>
        <Select
          labelId="source-select-label"
          value={caseType}
          onChange={(e) => setCaseType(e.target.value)}
          label="Case Type"
        >
          <MenuItem value="unwanted_spam">Unwanted Spam Texts/Calls</MenuItem>
          <MenuItem value="scam_recovery">Scam Recovery</MenuItem>
          <MenuItem value="both">Both</MenuItem>
        </Select>
      </FormControl>
      <FormControl required fullWidth margin="normal">
        <InputLabel id="source-select-label">Case Status</InputLabel>
        <Select
          labelId="source-select-label"
          value={caseStatus}
          onChange={(e) => setCaseStatus(e.target.value)}
          label="Case Status"
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="recovered">Recovered</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
          <MenuItem value="assigned">Assigned</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth required margin="normal">
        <InputLabel id="state-select-label">State</InputLabel>
        <Select
          labelId="state-select-label"
          name="state"
          value={states}
          onChange={(e) => setStates(e.target.value)}
          label="State"
        >
          {usStates.map((stateOption) => (
            <MenuItem key={stateOption} value={stateOption}>
              {stateOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl required fullWidth margin="normal">
        <InputLabel id="period-select-label">Occurrence Period</InputLabel>
        <Select
          labelId="period-select-label"
          value={selectedOccurancePeriod}
          onChange={(e) => handleOccurrencePeriodChange(e.target.value)}
          label="Occurrence Period"
        >
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="custom_dates">Custom Dates</MenuItem>
        </Select>
      </FormControl>

      {selectedOccurancePeriod === "custom_dates" && (
        <>
          <TextField
            required
            label="Start Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={startDate ? moment(startDate).format("YYYY-MM-DD") : ""}
            onChange={(e) => setStartDate(moment(e.target.value).toDate())}
            inputProps={{
              max: moment().format("YYYY-MM-DD"), // Disable future dates
            }}
          />
          <TextField
            required
            label="End Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={endDate ? moment(endDate).format("YYYY-MM-DD") : ""}
            onChange={(e) => setEndDate(moment(e.target.value).toDate())}
            inputProps={{
              max: moment().format("YYYY-MM-DD"), // Disable future dates
            }}
          />
        </>
      )}

      {/* Buttons */}
      <div className="text-end mt-3">
        <Button
          variant="outlined"
          startIcon={<UndoIcon />}
          onClick={clearFilters}
          sx={{ mr: 1 }}
        >
          Clear Filter
        </Button>
        <Button
          variant="contained"
          startIcon={<FilterListIcon />}
          onClick={handleApply}
        >
          Apply Filters
        </Button>
      </div>
    </form>
  );
}
